import classNames from 'classnames';
import { useState } from 'react';

import { AI } from '@/components/icon';
import { UrlInfo } from '@/interface/aigc';
import { UserResourceType } from '@/interface/library';
import { INewUploadIProps } from '@/interface/upload';
import AigcMusicDialog from '@/material/AigcMusicDialog';
import AigcVideoDialog from '@/material/AigcVideoDialog';

import { emitRichMediaFile, getRichLocalPath } from '../../../change-data';
import styles from '../index.module.less';

/**
 * AI 音乐 / 视频
 */
const UploadAIContent: React.FC<INewUploadIProps & {
  isHorizontal?: boolean;
  type?: UserResourceType;
}> = (props) => {
  const {
    value,
    disabled,
    promptText = '',
    isHorizontal = false,
    type = UserResourceType.RESOURCE_TYPE_AUDIO,
    onChange,
  } = props;

  const promptAi = promptText || value?.promptText || '';

  const [visibleAiAudio, setVisibleAiAudio] = useState(false);
  const [visibleAiVideo, setVisibleAiVideo] = useState(false);

  const closeAiDialog = () => {
    if (type === UserResourceType.RESOURCE_TYPE_VIDEO) {
      setVisibleAiVideo(false);
    } else {
      setVisibleAiAudio(false);
    }
  };

  const handleConfirm = async (urlInfo: UrlInfo, promptText?: string) => {
    const { url, name, volume = 100 } = urlInfo;
    emitRichMediaFile(url);
    const localPath = getRichLocalPath(url);
    const result = {
      ...value,
      volume,
      promptText,
      url: {
        ...value?.url,
        url,
        localPath,
        name: name || localPath,
      },
    };
    await onChange?.(result);
    closeAiDialog();
  };

  const openAiDialog = () => {
    if (disabled) {
      return;
    }
    if (type === UserResourceType.RESOURCE_TYPE_VIDEO) {
      setVisibleAiVideo(true);
    } else {
      setVisibleAiAudio(true);
    }
  };

  return (
    <>
      <div
        className={classNames(styles.item, {
          ['nova-disabled-opacity']: disabled,
          ['nova-disabled']: disabled,
        })}
        onClick={openAiDialog}
        style={{
          borderWidth: '0 1px',
          borderStyle: 'solid',
          borderColor: '#333333',
        }}
      >
        <div className={styles.textWrap}>
          <AI style={{ width: 18, height: 18 }} />
          <span>AI 生成</span>
        </div>
      </div>
      {type === UserResourceType.RESOURCE_TYPE_VIDEO
        ? <AigcVideoDialog
          visible={visibleAiVideo}
          onClose={closeAiDialog}
          onConfirm={handleConfirm}
          isHorizontal={isHorizontal}
          data={{
            promptText: promptAi,
          }}
        /> : <AigcMusicDialog
          visible={visibleAiAudio}
          onClose={closeAiDialog}
          onConfirm={handleConfirm}
          data={{
            promptText: promptAi,
          }}
        />}
    </>
  );
};

export default UploadAIContent;
